<template>
  <div
    :class="
      $style['promotion']
    "
    @click="onClick">
    <div
      :class="
        $style['promotion__background-one']
      " />
    <div
      :class="
        $style['promotion__background-two']
      " />
    <div :class="$style['promotion__inner']">
      <div :class="$style['promotion__row--0']">
        Online Only
      </div>
      <div :class="$style['promotion__row--1']">
        Free free free free free free
      </div>
      <div :class="$style['promotion__row--2']">
        Nailwraps Nailwraps Nailwraps Nailwraps Nailwraps
      </div>
      <div :class="$style['promotion__row--3']">
        With orders above €75
      </div>
      <Btn
        v-if="(promotionData.link && promotionData.showLink) && shouldShow(promotionData.link)"
        aria-label="Go to promotion"
        icon-only="System/arrow-right-s-line"
        color="cta"
        shape="round" />
    </div>
  </div>
</template>
<script>
import baseScript from './Shared/script'

export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/free-gift.webp');
  background-size: 101% 101%;
  border: 2px solid $grey-lighter;
  container: promotion / inline-size;

  &__inner {
    align-items: center;
    justify-content: center;
    color: white;
  }

  &__row {
    line-height: 0.9;

    &--0,
    &--1,
    &--2,
    &--3 {
      text-wrap: nowrap;
    }

    &--0 {
      font-size: clamp(1.3rem, 4.7cqw, 4.7cqw);
    }

    &--1 {
      margin-top: 2cqw;
      font-size: 36.7cqw;
      transform: translateX(36%);
      -webkit-text-stroke: .7cqw $white;
      color: transparent;
      line-height: 1;

      animation: swipe 10s infinite linear;
    }

    &--2 {
      font-size: 15.5cqw;
      line-height: 1;
      transform: translateX(-32.5%);
      margin-top: -3cqw;
      margin-bottom: 5cqw;
      animation: swipeReverse 10s infinite linear;
    }

    &--3 {
      font-size: clamp(1.3rem, 4.7cqw, 4.7cqw);
    }

  }
}

@keyframes swipe {
  0% {
    transform: translateX(36%);
  }

  99.99% {

    transform: translateX(-31.8%);
  }
}

@keyframes swipeReverse {
  0% {
    transform: translateX(-32.5%);
  }

  99.99% {

    transform: translateX(28%);
  }
}
</style>
